
<p class="utrecht-form-field__label utrecht-form-field__label--checkbox">
  <label
    for="{{ctx.instance.id}}-{{ctx.component.key}}"
    class="utrecht-form-label utrecht-form-label--checkbox utrecht-form-label--openforms {% if (ctx.disabled) { %}utrecht-form-label--disabled{% } %} {{ctx.input.labelClass}} {% if (ctx.component.validate.required && ctx.requiredFieldsWithAsterisk) { %}utrecht-form-label--openforms-required{% } %}"
  >
    {{ctx.input.label}}{% if (!ctx.component.validate.required && !ctx.requiredFieldsWithAsterisk) { %}&nbsp;{{ ctx.t('(not required)') }} {% } %}
    {% if (ctx.component.tooltip) { %}
      <i ref="tooltip" class="openforms-tooltip-icon {{ctx.iconClass('question-sign')}}" data-tooltip="{{ ctx.tooltip }}"></i>
    {% } %}
  </label>
</p>

<input
  ref="input"
  id="{{ctx.instance.id}}-{{ctx.component.key}}"

  {% for (var attr in ctx.input.attr) { %}
    {{attr}}="{{ctx.input.attr[attr]}}"
  {% } %}

  {% if (ctx.checked) { %}checked=true{% } %}
>
